import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypePrintablesQuickFiltersFields {
  displayTab: EntryFieldTypes.Symbol<'Maths' | 'Reader' | 'Reading' | 'Writing'>
  keywords: EntryFieldTypes.Array<EntryFieldTypes.Symbol>
}

export type TypePrintablesQuickFiltersSkeleton = EntrySkeletonType<
  TypePrintablesQuickFiltersFields,
  'printablesQuickFilters'
>
export type TypePrintablesQuickFilters<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode = LocaleCode,
> = Entry<TypePrintablesQuickFiltersSkeleton, Modifiers, Locales>

export function isTypePrintablesQuickFilters<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypePrintablesQuickFilters<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'printablesQuickFilters'
}

export type TypePrintablesQuickFiltersWithoutLinkResolutionResponse =
  TypePrintablesQuickFilters<'WITHOUT_LINK_RESOLUTION'>
export type TypePrintablesQuickFiltersWithoutUnresolvableLinksResponse =
  TypePrintablesQuickFilters<'WITHOUT_UNRESOLVABLE_LINKS'>
export type TypePrintablesQuickFiltersWithAllLocalesResponse<Locales extends LocaleCode = LocaleCode> =
  TypePrintablesQuickFilters<'WITH_ALL_LOCALES', Locales>
export type TypePrintablesQuickFiltersWithAllLocalesAndWithoutLinkResolutionResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypePrintablesQuickFilters<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>
export type TypePrintablesQuickFiltersWithAllLocalesAndWithoutUnresolvableLinksResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypePrintablesQuickFilters<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>
